// src/js/gsap.js
gsap.registerPlugin(ScrollTrigger, Flip, DrawSVGPlugin, SplitText, ScrollToPlugin, MorphSVGPlugin);
gsap.config({ force3D: true });
gsap.defaults({ lazy: false });

let flipCtx;
let horizontalCtx;
let scrubSwitchTimer;

/* =========================
   BLOB MORPH (turquoise + white)
========================= */
function initBlobMorph() {
  const turqPath = document.querySelector('.blob_turquoise > path');
  const whitePath = document.querySelector('.blob_white > path');
  if (!turqPath || !whitePath) return;

  const turqTargets = ['#blob_turq_egg', '#blob_turq_amorph', '#blob_turq_rect'];
  const whiteTargets = ['#blob_white_egg', '#blob_white_amorph', '#blob_white_rect'];

  const turqTl = gsap.timeline({ repeat: -1, defaults: { ease: 'sine.inOut', duration: 12 } });
  turqTargets.forEach((t) => turqTl.to(turqPath, { morphSVG: t }));
  turqTl.to(turqPath, { morphSVG: '#blob_turq_rect' });

  const whiteTl = gsap.timeline({ repeat: -1, defaults: { ease: 'sine.inOut', duration: 14 } });
  whiteTargets.forEach((t) => whiteTl.to(whitePath, { morphSVG: t }));
  whiteTl.to(whitePath, { morphSVG: '#blob_white_rect' });
}

document.addEventListener('DOMContentLoaded', initBlobMorph);

/* =========================
   FLIP SECTION
========================= */

function createTweenFlip() {
  const starterElement = document.querySelector('#starter');
  const starterWrapperBg = document.querySelector('.starter__wrap--bg');
  const horizontal__blob = document.querySelector('.horizontal__blob');
  if (!starterElement) return;

  const starterItems = starterElement.querySelectorAll('.starter__item');

  flipCtx && flipCtx.revert();
  starterElement.classList.remove('starter--final');

  const videos = starterElement.querySelectorAll('.starter__item:not(:nth-child(3)) video');
  const videosAll = starterElement.querySelectorAll('.starter__item video');

  gsap.set(videos, { scale: 1.5 });

  flipCtx = gsap.context(() => {
    starterElement.classList.add('starter--final');
    const flipState = Flip.getState(starterItems);
    starterElement.classList.remove('starter--final');

    const flip = Flip.to(flipState, {
      simple: true,
      ease: 'expoScale(1, 5)',
      duration: 8,
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: starterElement,
        start: 'center center',
        end: '+=300%',
        scrub: true,
        pin: starterElement.parentNode,
        pinSpacing: true,
        invalidateOnRefresh: true,
      },
    });

    window.__flipTimeline = tl;

    // Safari fix: play starter videos directly (IntersectionObserver unreliable in pinned sections)
    starterElement.querySelectorAll('video').forEach((v) => {
      v.play().catch(() => {});
    });

    tl.add(flip, 0);

    tl.to(
      videos,
      {
        scale: 1,
        ease: 'expoScale(1, 5)',
        duration: 6,
      },
      0,
    );

    videosAll.forEach((video, index) => {
      const groupIndex = Math.floor(index / 2);
      const isSecond = index % 2 === 1;

      const pos = isSecond ? `${groupIndex * 2}` : `${groupIndex * 2.5}`;

      tl.to(
        video,
        {
          delay: 8,
          autoAlpha: 0,
          duration: 2,
        },
        pos,
      );
    });

    // Reveal concept earlier: fade out entire starter element + bg + reveal blob
    // synced with 3rd-from-last video fadeout (so concept underneath shows through)
    const thirdFromLastIdx = Math.max(0, videosAll.length - 3);
    const tflGroup = Math.floor(thirdFromLastIdx / 2);
    const tflIsSecond = thirdFromLastIdx % 2 === 1;
    const tflPos = (tflIsSecond ? tflGroup * 2 : tflGroup * 2.5) + 8; // +8 delay

    tl.to(starterElement, { autoAlpha: 0, duration: 2.5, ease: 'power2.inOut' }, tflPos);
    tl.to(
      starterWrapperBg,
      { autoAlpha: 0, scaleY: 0, ease: 'expoScale(1, 5)', duration: 2 },
      tflPos,
    );
    tl.to(
      horizontal__blob,
      { autoAlpha: 0.2, scale: 1, ease: 'expoScale(1, 2.5)', duration: 4 },
      tflPos,
    );

    // Logo: idle fade + scroll-driven move to header
    const logo = document.querySelector('.site-header__logo');
    if (logo) {
      let idleTimer = null;
      let isFaded = false;
      let lastX = 0;
      let lastY = 0;
      let lastMoveTime = 0;

      function fadeOut() {
        if (!isFaded) {
          isFaded = true;
          gsap.to(logo, { opacity: 0.1, duration: 1.5, ease: 'power2.inOut' });
        }
      }

      function fadeIn() {
        if (isFaded) {
          isFaded = false;
          gsap.to(logo, { opacity: 1, duration: 0.4, ease: 'power2.out' });
        }
      }

      function startIdleTimer() {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(fadeOut, 1500);
      }

      function onMouseMove(e) {
        const now = Date.now();
        if (now - lastMoveTime < 50) return;
        lastMoveTime = now;

        const dx = Math.abs(e.clientX - lastX);
        const dy = Math.abs(e.clientY - lastY);

        if (dx > 10 || dy > 10) {
          lastX = e.clientX;
          lastY = e.clientY;
          fadeIn();
          startIdleTimer();
        }
      }

      function onScroll() {
        fadeIn();
        startIdleTimer();
      }

      function enableIdleTracking() {
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('scroll', onScroll);
        startIdleTimer();
      }

      function disableIdleTracking() {
        clearTimeout(idleTimer);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('scroll', onScroll);
        // Ensure logo is fully visible when idle tracking stops
        gsap.killTweensOf(logo, 'opacity');
        gsap.set(logo, { opacity: 1 });
        isFaded = false;
      }

      // Start idle tracking immediately
      enableIdleTracking();

      // Logo moves to header, synced with menu reveal
      const siteHeader = document.querySelector('.site-header');
      tl.to(
        logo,
        {
          y: 0,
          scale: 1,
          opacity: 1,
          ease: 'power2.inOut',
          duration: 5,
          onStart: () => {
            disableIdleTracking();
          },
          onComplete: () => {
            siteHeader && siteHeader.classList.add('header--menu-visible');
          },
          onReverseComplete: () => {
            siteHeader && siteHeader.classList.remove('header--menu-visible');
            enableIdleTracking();
          },
        },
        14,
      );

      // Enable pointer events after logo lands
      tl.set(logo, { pointerEvents: 'auto' }, 19);
    }

    // Menu items + socials reveal (synced with 2nd set of videos fading out)
    const navLeft = document.querySelector('.site-header__nav--left');
    const navRight = document.querySelector('.site-header__nav--right');
    const socialNav = document.querySelector('.site-social');

    const leftItems = navLeft ? navLeft.querySelectorAll('li') : [];
    const rightItems = navRight ? navRight.querySelectorAll('li') : [];

    if (navLeft && leftItems.length) {
      tl.to(navLeft, { opacity: 1, duration: 0.01 }, 14);
      tl.fromTo(
        leftItems,
        { opacity: 0, x: -30 },
        { opacity: 1, x: 0, duration: 2, stagger: 0.25, ease: 'power2.out' },
        14,
      );
    }

    if (navRight && rightItems.length) {
      tl.to(navRight, { opacity: 1, duration: 0.01 }, 14);
      tl.fromTo(
        rightItems,
        { opacity: 0, x: 30 },
        { opacity: 1, x: 0, duration: 2, stagger: 0.25, ease: 'power2.out' },
        14,
      );
    }

    if (socialNav) {
      tl.to(socialNav, { opacity: 1, duration: 2, ease: 'power2.out' }, 15);
    }
  }, starterElement);
}
/* =========================
   STACKED HORIZONTAL SECTION
========================= */

function createTweenHorizontal() {
  const section = document.querySelector('.horizontal');
  if (!section) return;

  const panels = gsap.utils.toArray('.horizontal .panel');
  if (!panels.length) return;

  horizontalCtx && horizontalCtx.revert();

  horizontalCtx = gsap.context(() => {
    // Pre-initialize SplitText PRZED master timeline
    const offerPanel = panels[1];
    let offerTitleSplits = [];

    if (offerPanel) {
      const offerTitles = offerPanel.querySelectorAll('.offer__title.split');

      if (offerTitles.length) {
        offerTitles.forEach((title, i) => {
          const split = new SplitText(title, {
            type: 'words,lines',
            linesClass: 'line-' + i,
            tag: 'div',
          });
          offerTitleSplits.push({ element: title, split: split, index: i });
        });
      }
    }

    gsap.set(panels, {
      xPercent: 100,
      autoAlpha: 0,
    });

    gsap.set(panels[0], {
      xPercent: 0,
      autoAlpha: 1,
    });

    gsap.set(panels, {
      zIndex: (i, target, targets) => targets.length - i,
    });

    // Start z scrub: true (instant) żeby przy refresh w środku strony
    // timeline natychmiast rozwiązał się do aktualnej pozycji scrolla.
    // Po pierwszym renderze przełączamy na scrub: 1.5 dla smooth experience.
    const master = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: `+=${panels.length * 200}%`,
        scrub: true,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        fastScrollEnd: 2000,
      },
    });

    // Wystawiamy master globalnie dla anchor scroll
    window.__horizontalMaster = master;

    // Po pierwszym renderze — przełącz scrub na smooth 1.5s
    // Anuluj poprzedni timer (ważne przy resize/recreate)
    cancelAnimationFrame(scrubSwitchTimer);
    scrubSwitchTimer = requestAnimationFrame(() => {
      scrubSwitchTimer = requestAnimationFrame(() => {
        const st = master.scrollTrigger;
        if (st) {
          st.vars.scrub = 1.5;
          st.scrubDuration(1.5);
        }
      });
    });

    master.addLabel('panel-concept', 0);

    /* =========================
     PANEL 1 – CONCEPT
  ========================= */

    const concept = panels[0];

    const title = concept.querySelector('.concept__title');
    const desc = concept.querySelector('.concept__desc');
    const cta = concept.querySelector('.concept__cta--wrapper');
    const aside = concept.querySelector('.concept__aside');
    const arrow = concept.querySelector('.concept__scroll-arrow');

    master
      .from(title, { y: 80, autoAlpha: 0, scale: 0.8, duration: 3 })
      .from(desc, { y: 100, autoAlpha: 0, scale: 0.9, duration: 3 }, '>-1')
      .from(cta, { y: -100, autoAlpha: 0, scale: 0.9, duration: 3 }, '>-1')
      .from(aside, { autoAlpha: 0, duration: 0.6 }, '<0.2')
      .from(arrow, { autoAlpha: 0, duration: 0.6 }, '<0.2')
      .addLabel('concept-ready')
      .to({}, { duration: 4 }); // pauza — concept widoczny przed wyjazdem

    master
      .addLabel('concept-exit')
      // Wyjazd desc i title w lewo
      .to([cta, desc], { x: -100, autoAlpha: 0, duration: 3.8, ease: 'power2.inOut' }, '+=0.4');

    // Zapamiętaj absolutną pozycję na timeline (start fadeoutu cta/desc) dla SVG reveal
    const svgRevealTime = master.recent().startTime();
    master.addLabel('offer-svg-reveal', svgRevealTime);

    master
      // Powiększenie i zniknięcie samego title
      .to(title, { scale: 1.2, autoAlpha: 0, duration: 4.4, ease: 'power2.in' }, '<0.5')
      // Aside przesuwa się z prawej do lewej (translatX)
      .to(aside, { x: '-95vw', duration: 4, ease: 'power2.inOut' }, '>-1');

    // Start ruchu aside (absolutna pozycja)
    const asideStartTime = master.recent().startTime();
    master.addLabel('aside-start', asideStartTime);

    /* ===== PANEL 2 – crossfade zamiast slide ===== */
    const panel2 = panels[1];

    // Ustaw panel 2 na pozycji 0 (stackowany nad concept)
    gsap.set(panel2, { xPercent: 0, autoAlpha: 0 });

    // Panel offer fade-in WCZEŚNIE — razem ze startem fadeoutu cta/desc (offer-svg-reveal)
    // żeby SVG i tytuły na nim były widoczne podczas znikania concept elementów
    master.to(panel2, { autoAlpha: 1, duration: 2.5, ease: 'power2.out' }, 'offer-svg-reveal');

    // Concept całościowy fade out + arrow + zIndex cleanup pod koniec aside exit
    master
      .to(concept, { autoAlpha: 0, duration: 1.5, ease: 'power2.in' }, '>-1.5')
      .to(arrow, { autoAlpha: 0, duration: 0.6 }, '<')
      .set(concept, { zIndex: -1, pointerEvents: 'none' })
      .addLabel('panel-offer');

    /* =========================
     PANEL 2 – OFFER ANIMATIONS
  ========================= */

    if (offerPanel) {
      const offerSVGPlaceholder = offerPanel.querySelector('.offer__svg-placeholder');
      const slateLetters = offerPanel.querySelectorAll('.slate-letter');
      const offerVideoWrapper = offerPanel.querySelector('.offer__video-wrapper');

      // Phase 1: SVG SLATE animation (DrawSVG - niezależny timeline)
      let slateSVGTimeline = null;

      function createSlateAnimation() {
        if (!slateLetters.length) return;

        slateSVGTimeline = gsap.timeline({ paused: true });

        // S - litera 0 (z-index 5)
        const letterS = slateLetters[0].querySelector('path');
        if (letterS) {
          slateSVGTimeline.from(letterS, {
            drawSVG: 0,
            duration: 1.5,
            ease: 'power1.inOut',
          });
        }

        // L - litera 1 (S znika, L rysuje się)
        const letterL = slateLetters[1].querySelector('path');
        if (letterL) {
          slateSVGTimeline.to(slateLetters[0], { autoAlpha: 0, duration: 0.5 }, '+=0.6').from(
            letterL,
            {
              drawSVG: 0,
              duration: 1.2,
            },
            '<',
          );
        }

        // A - litera 2 (L znika, A rysuje się)
        const letterAPaths = slateLetters[2].querySelectorAll('path');
        if (letterAPaths.length) {
          slateSVGTimeline.to(slateLetters[1], { autoAlpha: 0, duration: 0.5 }, '+=0.6').from(
            letterAPaths,
            {
              drawSVG: 0,
              duration: 1.3,
              stagger: 0.2,
            },
            '<',
          );
        }

        // T - litera 3 (A znika, T rysuje się)
        const letterT = slateLetters[3].querySelector('path');
        if (letterT) {
          slateSVGTimeline.to(slateLetters[2], { autoAlpha: 0, duration: 0.5 }, '+=0.6').from(
            letterT,
            {
              drawSVG: 0,
              duration: 1.2,
            },
            '<',
          );
        }

        // E - litera 4 (T znika, E rysuje się)
        const letterEPath = slateLetters[4].querySelector('path');
        const letterEPolygon = slateLetters[4].querySelector('polygon');
        if (letterEPath && letterEPolygon) {
          slateSVGTimeline.to(slateLetters[3], { autoAlpha: 0, duration: 0.5 }, '+=0.6').from(
            [letterEPath, letterEPolygon],
            {
              drawSVG: 0,
              duration: 1.5,
              stagger: 0.25,
            },
            '<',
          );
        }

        // Po narysowaniu wszystkich - crossfade między literami (tylko jedna widoczna)
        slateSVGTimeline.call(
          () => {
            // Najpierw ukryj wszystkie
            gsap.set(slateLetters, { autoAlpha: 0 });

            // Crossfade loop - tylko jedna litera na raz
            const crossfadeTimeline = gsap.timeline({ repeat: -1 });
            slateLetters.forEach((letter, i) => {
              crossfadeTimeline
                .to(letter, { autoAlpha: 1, duration: 0.5 }, i === 0 ? 0 : '+=0.3')
                .to(letter, { autoAlpha: 0, duration: 0.5 }, '+=1');
            });
          },
          null,
          '+=0.5',
        );
      }

      createSlateAnimation();

      // Phase 2: Tytuły Offer (SplitText - już zainicjalizowane)
      // Phase 3: Animacje ofert (tytuły + wideo + opisy)
      const offerElements = Array.from(offerPanel.querySelectorAll('[data-index]')).reduce(
        (acc, el) => {
          const index = el.dataset.index;
          if (!acc[index]) acc[index] = {};

          if (el.classList.contains('offer__title')) acc[index].title = el;
          if (el.classList.contains('offer__desc')) acc[index].desc = el;
          if (el.classList.contains('offer__video')) acc[index].video = el;

          return acc;
        },
        {},
      );

      const offerCount = Object.keys(offerElements).length;

      if (offerCount > 0) {
        const firstOffer = offerElements[0];

        if (firstOffer.title && firstOffer.video) {
          // === OFFER INTRO (scrub-driven on master) ===

          // 1. SVG SLATE reveal — pojawia się gdy concept zanika (offer-svg-reveal label)
          if (slateSVGTimeline && offerSVGPlaceholder) {
            master.to(
              offerSVGPlaceholder,
              {
                autoAlpha: 1,
                duration: 1.2,
                onStart: () => {
                  if (slateSVGTimeline) slateSVGTimeline.play();
                },
              },
              'offer-svg-reveal',
            );
          }

          // 2. SplitText tytuły wjazd — po kolei (żaluzja), start razem z SVG
          //    (gdy zanikają concept title/desc/cta)
          if (offerTitleSplits.length) {
            offerTitleSplits.forEach((titleData, i) => {
              const lines = titleData.element.querySelectorAll(
                '[class*="line-' + titleData.index + '"]',
              );
              if (lines.length) {
                master.from(
                  lines,
                  {
                    yPercent: 100,
                    opacity: 0,
                    stagger: 0.05,
                    duration: 1.25,
                    ease: 'expo.out',
                  },
                  i === 0 ? 'offer-svg-reveal' : '+=0.1',
                );
                // Label przy starcie 3. tytułu — moment startu video fullscreen
                if (i === 2) {
                  master.addLabel('offer-title-3', master.recent().startTime());
                }
              }
            });
          }

          // 3. Lazy load offer videos — razem ze startem 3. tytułu (przygotowanie pod video)
          master.call(
            () => {
              offerPanel.querySelectorAll('.offer__video source[data-src]').forEach((source) => {
                if (!source.src) {
                  source.src = source.dataset.src;
                  source.parentElement.load();
                  source.parentElement.play().catch(() => {});
                }
              });
            },
            null,
            'offer-title-3',
          );

          // 4. SVG SLATE fadeout — gdy 3. tytuł wjeżdża, SVG ustępuje miejsca videu
          if (offerSVGPlaceholder) {
            master.to(
              offerSVGPlaceholder,
              {
                autoAlpha: 0,
                duration: 0.52,
                ease: 'power2.in',
              },
              'offer-title-3',
            );
          }

          // 5. Video fullscreen (transparent) — start gdy wjeżdża 3. tytuł
          master.to(firstOffer.video, { autoAlpha: 0.3, duration: 0.65 }, 'offer-title-3');

          // 6. Video wrapper shrink + video opaque + first desc — wydłużone i wygładzone
          if (offerVideoWrapper) {
            master.to(
              offerVideoWrapper,
              {
                scale: 0.55,
                borderRadius: '1rem',
                duration: 2.6,
                ease: 'power3.inOut',
              },
              '+=0.065',
            );
          }
          master.to(
            firstOffer.video,
            { autoAlpha: 1, duration: 1.3, ease: 'power2.out' },
            '<0.325',
          );
          if (firstOffer.desc) {
            master.to(firstOffer.desc, { autoAlpha: 1, duration: 0.52 }, '<0.2');
          }

          // 7. First offer active
          master.call(() => {
            offerPanel
              .querySelectorAll('.offer__title')
              .forEach((t) => t.classList.remove('is-active'));
            firstOffer.title.classList.add('is-active');
          });

          // === SPACER + SNAP: first offer visible ===
          master.addLabel('offerActive-0');
          master.to({}, { duration: 8 }); // spacer offer

          // === CROSSFADE BETWEEN OFFERS ===
          for (let i = 1; i < offerCount; i++) {
            const prev = offerElements[i - 1];
            const curr = offerElements[i];

            // Video crossfade
            if (prev.video) master.to(prev.video, { autoAlpha: 0, duration: 1.2 });
            if (curr.video) master.to(curr.video, { autoAlpha: 1, duration: 1.2 }, '<');

            // Desc swap
            if (prev.desc) master.to(prev.desc, { autoAlpha: 0, duration: 0.8 }, '<');
            if (curr.desc) master.to(curr.desc, { autoAlpha: 1, duration: 0.8 }, '<0.2');

            // is-active class swap
            master.call(() => {
              offerPanel
                .querySelectorAll('.offer__title')
                .forEach((t) => t.classList.remove('is-active'));
              if (curr.title) curr.title.classList.add('is-active');
            });

            // Snap label + spacer po każdej ofercie
            master.addLabel('offerActive-' + i);
            master.to({}, { duration: 6 });
          }

          // Click navigation — instant active swap + ostry snap scroll
          const offerTitles = offerPanel.querySelectorAll('.offer__title[data-index]');
          offerTitles.forEach((title) => {
            title.style.cursor = 'pointer';
            title.addEventListener('click', () => {
              const index = parseInt(title.dataset.index, 10);
              if (isNaN(index)) return;
              const labelName = 'offerActive-' + index;
              const labelTime = master.labels[labelName];
              if (labelTime === undefined) return;
              const st = master.scrollTrigger;
              if (!st) return;

              // Instant: klasa is-active leci na klikniętym natychmiast (nie czekamy na scrub)
              offerPanel
                .querySelectorAll('.offer__title')
                .forEach((t) => t.classList.remove('is-active'));
              title.classList.add('is-active');

              // Wymuś scrub do 0 na czas skoku — bez tego scrub 1.5s rozjeżdża się z scrollem
              // i wizualnie "dochodzi" sekundę po locie scrolla
              const prevScrub = st.scrubDuration ? st.getTween()?.duration() : null;
              st.scrubDuration(0);

              const progress = labelTime / master.duration();
              const targetY = st.start + progress * (st.end - st.start);
              gsap.to(window, {
                scrollTo: { y: targetY, autoKill: false },
                duration: 0.25,
                ease: 'power2.out',
                onComplete: () => {
                  st.scrubDuration(1.5);
                },
              });
            });
          });

          // === OFFER EXIT + PORTFOLIO ENTRANCE ===
          const lastOfferIndex = offerCount - 1;
          const lastOffer = offerElements[lastOfferIndex];
          const panel3 = panels[2];

          if (panel3) {
            const portfolioContainer = panel3.querySelector('.container');
            const portfolioFilters = panel3.querySelector('.portfolio__filters:not(.mobile)');

            // Przygotuj panel 3 — stackowany pod panel 2
            gsap.set(panel3, { xPercent: 0, autoAlpha: 0 });

            // Container od razu na miejscu (bez translate)
            if (portfolioContainer) {
              gsap.set(portfolioContainer, { x: 0 });
            }

            // Filtry ukryte osobno (fade in na końcu)
            if (portfolioFilters) {
              gsap.set(portfolioFilters, { autoAlpha: 0, y: 30 });
            }

            // Tytuł i grid startują ukryte
            const portfolioTitleWrap = panel3.querySelector('.portfolio__title-wrap');
            const portfolioItemsContainer = panel3.querySelector('.portfolio__items-container');

            if (portfolioTitleWrap) {
              gsap.set(portfolioTitleWrap, { autoAlpha: 0, x: -60 });
            }
            if (portfolioItemsContainer) {
              gsap.set(portfolioItemsContainer, { autoAlpha: 0, x: 80 });
            }

            // 1. Opis ostatniej oferty fade out
            if (lastOffer.desc) {
              master.to(lastOffer.desc, { y: 100, autoAlpha: 0, duration: 0.8 }, '+=0.3');
            }

            // 2. Tytuły ofert za lewą krawędź + panel2 fade out + portfolio fade in (overlap)
            master.addLabel('offer-exit');
            const offerItems = offerPanel.querySelector('.offer__items');
            if (offerItems) {
              master.to(offerItems, { x: '-100vw', duration: 1.2, ease: 'power2.inOut' }, '+=0.2');
            }

            // 3. Crossfade offer→portfolio — nakłada się na wyjazd tytułów
            master
              .to(panel2, { autoAlpha: 0, duration: 1.5, ease: 'power2.in' }, '>-0.8')
              .to(panel3, { autoAlpha: 1, duration: 1.5 }, '<')
              .set(panel2, { zIndex: -1, pointerEvents: 'none' })
              .addLabel('panel-portfolio');

            // 4. Video offer scale down + fade out — startuje razem z wyjazdem tytułów
            if (offerVideoWrapper) {
              master.to(
                offerVideoWrapper,
                {
                  scale: 0.15,
                  autoAlpha: 0,
                  duration: 2,
                  ease: 'power2.in',
                },
                'offer-exit',
              );
            }

            // Tytuł portfolio wjeżdża z lewej — start gdy tytuły offer są w 50% wyjazdu
            // (offer-exit + 0.6 = połowa duration:1.2 wyjazdu offer items)
            if (portfolioTitleWrap) {
              master.to(
                portfolioTitleWrap,
                {
                  autoAlpha: 1,
                  x: 0,
                  duration: 10,
                  ease: 'power2.out',
                },
                'offer-exit+=0.6',
              );
            }

            // Grid wjeżdża z prawej — start gdy tytuł portfolio jest w 50% wjazdu
            // (50% z 10s = 5s, więc offer-exit + 0.6 + 5 = 5.6)
            if (portfolioItemsContainer) {
              master.to(
                portfolioItemsContainer,
                {
                  autoAlpha: 1,
                  x: 0,
                  duration: 12,
                  ease: 'power2.out',
                },
                'offer-exit+=5.6',
              );
            }

            // 5. Tytuł wyjeżdża za lewą krawędź, grid przesuwa się w lewo żeby wypełnić miejsce
            if (portfolioTitleWrap) {
              // Pauza — tytuł + grid widoczne razem
              master.to({}, { duration: 0.8 });
              master.addLabel('portfolio-ready');

              const titleExitLabel = 'titleExit';

              master.to(
                portfolioTitleWrap,
                {
                  autoAlpha: 0,
                  x: -80,
                  duration: 2.5,
                  ease: 'power2.inOut',
                },
                titleExitLabel,
              );

              // Grid przesuwa się w lewo o szerokość tytułu + gap
              if (portfolioItemsContainer) {
                const titleShift = () => {
                  const titleW = portfolioTitleWrap.offsetWidth;
                  const gap = parseFloat(getComputedStyle(portfolioContainer).gap) || 32;
                  return -(titleW + gap);
                };
                master.to(
                  portfolioItemsContainer,
                  {
                    x: titleShift,
                    duration: 2.5,
                    ease: 'power2.inOut',
                  },
                  titleExitLabel,
                );
              }
            }

            // 6. Filtry fade in gdy tytuł znikł i grid zajął pełną szerokość (po zakończeniu titleExit)
            if (portfolioFilters) {
              master.to(
                portfolioFilters,
                {
                  autoAlpha: 1,
                  y: 0,
                  duration: 0.8,
                },
                'titleExit+=2.5',
              );
            }

            // === PORTFOLIO EXIT + TRUST ENTRANCE ===
            const panel4 = panels[3]; // .panel--trust

            if (panel4) {
              gsap.set(panel4, { xPercent: 0, autoAlpha: 0 });

              const trustTitle = panel4.querySelector('.trust__title');
              const trustLogos = panel4.querySelector('.trust__logos');
              const logos = panel4.querySelectorAll('.trust__logo');

              // 1. Portfolio items shrink + fade
              const portfolioItems = panel3.querySelectorAll('.portfolio__item');

              // Pauza — grid portfolio widoczny na ekranie
              master.to({}, { duration: 4.5 });

              // Filtry i tytuł fade out pierwsze
              if (portfolioFilters) {
                master.to(
                  portfolioFilters,
                  { autoAlpha: 0, y: -20, duration: 2.4, ease: 'power2.in' },
                  '+=0.2',
                );
              }
              if (portfolioTitleWrap) {
                master.to(
                  portfolioTitleWrap,
                  { autoAlpha: 0, x: -60, duration: 3, ease: 'power2.in' },
                  '<0.2',
                );
              }

              // Items rozpadają się — scale + fade ze staggerem
              master.to(
                portfolioItems,
                {
                  scale: 0.75,
                  autoAlpha: 0,
                  y: 30,
                  stagger: { each: 0.15, from: 'center' },
                  duration: 3.6,
                  ease: 'power2.in',
                },
                '>-0.4',
              );
              // Label na start fadeoutu items (do oznaczeń %)
              const portfolioItemsExitStart = master.recent().startTime();
              master.addLabel('portfolio-items-exit', portfolioItemsExitStart);

              // Czarne tło (panel3) znika WCZEŚNIEJ niż items — równolegle z ich fadeoutem,
              // ale szybciej, żeby zniknęło zanim items skończą (~przy 60% ich fadeout)
              master.to(
                panel3,
                { autoAlpha: 0, duration: 2.2, ease: 'power2.in' },
                'portfolio-items-exit',
              );

              // Panel swap — panel4 fade-in WCZEŚNIE (równolegle z items fadeout)
              // żeby trust title był widoczny na ekranie zanim items znikną
              master.call(
                () => {
                  const allRadio = panel3.querySelector(
                    'input[name="portfolio-filter"][value="all"]',
                  );
                  if (allRadio) allRadio.checked = true;
                  portfolioItems.forEach((item) => {
                    item.style.display = 'inline-flex';
                    gsap.set(item, {
                      clearProps: 'transform,opacity,position,top,left,width,height,margin,padding',
                    });
                  });
                },
                null,
                'portfolio-items-exit+=0.5',
              );
              master
                .to(
                  panel4,
                  { autoAlpha: 1, duration: 1.5, ease: 'power2.out' },
                  'portfolio-items-exit',
                )
                .set(panel3, { zIndex: -1, pointerEvents: 'none' }, 'portfolio-items-exit+=2.2')
                .addLabel('panel-trust', 'portfolio-items-exit+=1.5');

              // 3. Trust title — pojawia się w trakcie items fadeout (3.6 * 0.4 = 1.44),
              // żeby przy 70% zniknięcia items był już widoczny
              if (trustTitle) {
                master.fromTo(
                  trustTitle,
                  { autoAlpha: 0, y: -40 },
                  { autoAlpha: 1, y: 0, duration: 1.2, ease: 'power2.out' },
                  'portfolio-items-exit+=1.4',
                );
                // Logosy startują tuż po starcie wjazdu title — niemal równolegle
                master.addLabel('trust-title-50', 'portfolio-items-exit+=0.5');
              }

              // Zmienne dostępne też w bloku passion poniżej
              let trustTitleExitStart = null;
              let passionVideoRect = null;

              // 4. Logos scroll in shared container — startują razem z tytułem
              if (trustLogos && logos.length) {
                logos.forEach((logo, idx) => {
                  const yOffset = idx % 2 === 0 ? -175 : 175;
                  const rotateVal = idx % 2 === 0 ? -23 : 23;
                  gsap.set(logo, { y: yOffset, rotation: rotateVal, autoAlpha: 0.15 });
                });

                const containerW = trustLogos.scrollWidth;
                const viewportW = window.innerWidth;

                const startX = viewportW;
                const endX = -(containerW + viewportW * 0.25);
                const totalTravelPx = startX - endX;

                gsap.set(trustLogos, { x: startX });

                const scrollDuration = totalTravelPx / (viewportW * 0.08);

                // Label as anchor — won't shift when later tweens extend the timeline
                master.addLabel('trustScroll');
                master.to(
                  trustLogos,
                  { x: endX, duration: scrollDuration, ease: 'none' },
                  'trust-title-50', // start gdy trust title widoczny w 50%
                );

                const pxPerSec = totalTravelPx / scrollDuration;

                // Get title right edge using offsets (works even when panel is hidden)
                // Walk up offsetParent chain to get absolute position
                function getAbsoluteLeft(el) {
                  let x = 0;
                  while (el && el !== panel4) {
                    x += el.offsetLeft;
                    el = el.offsetParent;
                  }
                  return x;
                }

                const titleAbsLeft = trustTitle ? getAbsoluteLeft(trustTitle) : 0;
                const titleW = trustTitle ? trustTitle.offsetWidth : 0;
                const titleRightPx = titleAbsLeft + titleW; // px from panel left edge

                const containerAbsLeft = getAbsoluteLeft(trustLogos);

                logos.forEach((logo, idx) => {
                  const logoOffsetInContainer = logo.offsetLeft;
                  const viewportW = window.innerWidth;
                  const triggerX = viewportW * 1.6; // 20% od prawej krawędzi

                  // Trigger: logo dociera do 80% szerokości viewportu (wcześniej niż titleRightPx)
                  const tTrigger =
                    (containerAbsLeft + startX + logoOffsetInContainer - triggerX) / pxPerSec;

                  // Dynamiczny czas lądowania: od triggerX do titleRightPx
                  const landingDuration = (triggerX - titleRightPx) / pxPerSec;

                  // Opacity: od triggerX do titleRightPx
                  master.to(
                    logo,
                    {
                      autoAlpha: 1,
                      duration: landingDuration,
                      ease: 'power1.out',
                    },
                    'trustScroll+=' + Math.max(0, tTrigger),
                  );

                  // Straighten: od triggerX do titleRightPx (łagodniejszy ease)
                  master.to(
                    logo,
                    {
                      y: 0,
                      rotation: 0,
                      duration: landingDuration,
                      ease: 'power1.out',
                    },
                    'trustScroll+=' + Math.max(0, tTrigger),
                  );
                });

                // 5. Trust exit: title zaczyna znikać gdy 80% logosów wyjechało
                trustTitleExitStart = 'trustScroll+=' + scrollDuration * 0.8;
                if (trustTitle) {
                  master.to(
                    trustTitle,
                    {
                      scale: 1.2,
                      autoAlpha: 0,
                      duration: 4.4,
                      ease: 'power2.in',
                    },
                    trustTitleExitStart,
                  );
                  // Label przy 80% ukrycia trust title
                  master.addLabel(
                    'trust-exit-80',
                    'trustScroll+=' + (scrollDuration * 0.8 + 4.4 * 0.8),
                  );
                }

                // Passion video — start RAZEM ze startem trust title exit
                const passionPanel = panels[4];
                if (passionPanel) {
                  gsap.set(passionPanel, { xPercent: 0, autoAlpha: 0 });
                }
                const passionVideoEl = passionPanel
                  ? passionPanel.querySelector('.passion__video-wrap')
                  : null;
                if (passionVideoEl) {
                  const vw = window.innerWidth;
                  passionVideoRect = passionVideoEl.getBoundingClientRect();
                  const startOffsetX = vw - passionVideoRect.left + 50;
                  gsap.set(passionVideoEl, {
                    x: startOffsetX,
                    autoAlpha: 1,
                    filter: 'blur(8px)',
                  });
                  // Panel5 fade-in równolegle z video (żeby video było widoczne)
                  master.to(
                    passionPanel,
                    { autoAlpha: 1, duration: 1.5, ease: 'power2.out' },
                    trustTitleExitStart,
                  );
                  master.to(
                    passionVideoEl,
                    {
                      x: 0,
                      filter: 'blur(0px)',
                      duration: 10,
                      ease: 'power1.out',
                    },
                    trustTitleExitStart,
                  );
                }
              }

              // === TRUST EXIT + PASSION ENTRANCE ===
              const panel5 = panels[4]; // .panel--passion

              if (panel5) {
                const passionTitle = panel5.querySelector('.passion__title');
                const passionDescPs = panel5.querySelectorAll('.passion__desc p');
                const passionVideo = panel5.querySelector('.passion__video-wrap');
                const passionText = panel5.querySelector('.passion__text');

                // 1. Panel swap — panel4 fade-out gdy trust title 80% schowany
                master
                  .to(panel4, { zIndex: -1, autoAlpha: 0, pointerEvents: 'none' }, 'trust-exit-80')
                  .addLabel('panel-passion', 'trust-exit-80');

                // 2. Tytuł — pojawia się gdy trust title jest w 80% schowany
                if (passionTitle) {
                  master.fromTo(
                    passionTitle,
                    { autoAlpha: 0, scale: 0.4 },
                    { autoAlpha: 1, scale: 1, duration: 2.5, ease: 'power2.out' },
                    'trust-exit-80',
                  );
                }

                // 3. Paragrafy — wysuwają się w dół po kolei
                if (passionDescPs.length) {
                  master.fromTo(
                    passionDescPs,
                    { autoAlpha: 0, y: -30 },
                    { autoAlpha: 1, y: 0, duration: 4.2, stagger: 2.4, ease: 'power2.out' },
                    '>-0.5',
                  );
                }

                // 4. Video już wcześniej wjechało (od trustTitleExitStart)
                if (passionVideo) {
                  // Rect potrzebny do exit/coupling poniżej
                  const videoRect = passionVideoRect || passionVideo.getBoundingClientRect();

                  // 5. Pauza
                  master.addLabel('passion-ready');
                  master.to({}, { duration: 8 });

                  // 6. Video jedzie w lewo za lewą krawędź ekranu + sprzęgnięcie tekstu
                  master.addLabel('passionExit');

                  // Dystans do wyjścia za lewą krawędź ekranu
                  const exitX = -(videoRect.left + videoRect.width + 50);

                  master.to(
                    passionVideo,
                    {
                      x: exitX,
                      duration: 12,
                      ease: 'none',
                    },
                    'passionExit',
                  );

                  // Coupling: video w 100% mija lewą krawędź tekstu + 3rem gap
                  // → tekst dokleja się do video i razem jadą z tą samą prędkością
                  if (passionText) {
                    const textRect = passionText.getBoundingClientRect();
                    const gap = parseFloat(getComputedStyle(document.documentElement).fontSize) * 3;
                    const couplingX = textRect.left - gap - videoRect.right; // ujemne
                    const videoSpeed = Math.abs(exitX) / 12; // px/s (duration = 12)
                    const couplingTime = Math.abs(couplingX) / videoSpeed;

                    // Tekst startuje z x=0, musi wyjechać za lewą krawędź ekranu
                    // Jedzie z tą samą prędkością co video (ta sama ease:none)
                    const textExitX = -(textRect.right + 50);
                    const textDuration = Math.abs(textExitX) / videoSpeed;
                    master.to(
                      passionText,
                      {
                        x: textExitX,
                        duration: textDuration,
                        ease: 'none',
                      },
                      'passionExit+=' + couplingTime,
                    );
                    // Label moment "spięcia" tekstu z video — anchor dla awards entrance
                    master.addLabel('passion-coupling', 'passionExit+=' + couplingTime);
                  }
                }

                // === PASSION EXIT + AWARDS ENTRANCE ===
                const panel6 = panels[5]; // .panel--awards

                if (panel6) {
                  gsap.set(panel6, { xPercent: 0, autoAlpha: 0 });

                  const awardsTitle = panel6.querySelector('.awards__title');
                  const awardsRows = panel6.querySelectorAll('.awards__row');
                  const awardsLeft = panel6.querySelector('.awards__left');
                  const awardsLogosGrid = panel6.querySelector('.awards__logos-grid');
                  const awardsLogos = panel6.querySelectorAll('.awards__logos-grid img');

                  // 1. Panel swap — startuje gdy passion text spina się z video (passion-coupling)
                  master
                    .to(
                      panel5,
                      { zIndex: -1, autoAlpha: 0, pointerEvents: 'none', duration: 1.5 },
                      'passion-coupling',
                    )
                    .to(panel6, { autoAlpha: 1, duration: 1.5 }, 'passion-coupling');

                  // 2. Tytuł — reveal od góry do dołu, razem z panel swap
                  if (awardsTitle) {
                    gsap.set(awardsTitle, { autoAlpha: 1, clipPath: 'inset(0 0 100% 0)' });
                    master.to(
                      awardsTitle,
                      {
                        clipPath: 'inset(0 0 0% 0)',
                        duration: 4.5,
                        ease: 'power2.out',
                      },
                      'passion-coupling',
                    );
                  }

                  // 3. Rząd 1 lewy — logo + opis (fade in + slide up), tuż po tytule
                  if (awardsRows.length > 0) {
                    master.fromTo(
                      awardsRows[0],
                      { autoAlpha: 0, y: 30 },
                      { autoAlpha: 1, y: 0, duration: 3, ease: 'power2.out' },
                      'passion-coupling+=1.2',
                    );
                  }

                  // 4. Border separator rysuje się (scaleY 0→1 via CSS custom property)
                  if (awardsLeft) {
                    master.to(
                      awardsLeft,
                      {
                        '--border-scale': 1,
                        duration: 4.5,
                        ease: 'power2.inOut',
                      },
                      '>-0.9',
                    );
                  }

                  // 5. Rząd 2 lewy — wchodzi w trakcie rysowania bordera
                  if (awardsRows.length > 1) {
                    master.fromTo(
                      awardsRows[1],
                      { autoAlpha: 0, y: 30 },
                      { autoAlpha: 1, y: 0, duration: 3, ease: 'power2.out' },
                      '>-2.4',
                    );
                    master.addLabel('row2Start', '<');
                  }

                  // 6. Logos grid kontener — fade in razem z pierwszym opisem (rząd 1)
                  //    żeby logosy mogły zacząć wjeżdżać razem z opisem
                  if (awardsLogosGrid) {
                    master.to(
                      awardsLogosGrid,
                      { autoAlpha: 1, duration: 1.2 },
                      'passion-coupling+=1.2',
                    );
                  }

                  // 7. Loga — scroll-driven, wchodzą RZĘDAMI (cały rząd jednocześnie).
                  //    Grid ma 3 kolumny na desktop → chunki po 3 logo = rząd.
                  //    Start razem z pierwszym opisem (passion-coupling+=1.2),
                  //    między rzędami przerwa scrollowa.
                  if (awardsLogos.length) {
                    gsap.set(awardsLogos, { autoAlpha: 0, scale: 0.3 });

                    const COLS = 3; // matches grid-template-columns: repeat(3, 1fr) @ laptop
                    const rowChunks = [];
                    for (let i = 0; i < awardsLogos.length; i += COLS) {
                      rowChunks.push(Array.from(awardsLogos).slice(i, i + COLS));
                    }

                    rowChunks.forEach((row, idx) => {
                      // pierwszy rząd startuje razem z opisem rzędu 1,
                      // kolejne rzędy z przerwą scrollową między sobą
                      const position =
                        idx === 0 ? 'passion-coupling+=1.2' : '>+=0.5';
                      master.to(
                        row,
                        {
                          autoAlpha: 1,
                          scale: 1,
                          duration: 1.4,
                          ease: 'back.out(1.7)',
                        },
                        position,
                      );
                    });
                  }

                  // === AWARDS EXIT + CONTACT ENTRANCE ===
                  const panel7 = panels[6]; // .panel--contact

                  if (panel7) {
                    // Contact startuje niewidoczny, przeskalowany i rozmyty (daleko)
                    gsap.set(panel7, {
                      xPercent: 0,
                      autoAlpha: 0,
                      scale: 1.15,
                      filter: 'blur(6px)',
                    });

                    // 1. Awards odpływa w tył (scale down + blur + fade)
                    master.to(panel6, {
                      scale: 0.8,
                      autoAlpha: 0,
                      filter: 'blur(4px)',
                      duration: 3,
                      ease: 'power2.in',
                      pointerEvents: 'none',
                    });

                    // 2. Contact przybliża się z daleka (odwrotność awards exit)
                    master.to(
                      panel7,
                      {
                        autoAlpha: 1,
                        scale: 1,
                        filter: 'blur(0px)',
                        duration: 4.5,
                        ease: 'power2.out',
                      },
                      '>-0.5',
                    );
                    master.addLabel('panel-contact');
                  }
                }
              }
            }
          }
        }
      }
    }

  }, section);
}

/* =========================
   PORTFOLIO: Flip Modal + Filtering
========================= */

function initPortfolio() {
  const modal = document.querySelector('.portfolio__modal');
  if (!modal) return;

  const modalContent = modal.querySelector('.portfolio__modal-content');
  const modalOverlay = modal.querySelector('.portfolio__modal-overlay');
  const modalTitle = modal.querySelector('.portfolio__modal-title');
  const modalDesc = modal.querySelector('.portfolio__modal-desc');
  const modalFooter = modal.querySelector('.portfolio__modal-footer');
  const items = gsap.utils.toArray('.portfolio__item');
  const itemContents = gsap.utils.toArray('.portfolio__item-content');
  let activeIndex;

  // FORCE: Clear any inline display styles on init (all items visible by default)
  items.forEach((item) => {
    item.style.display = '';

    // Video hover play/pause (always muted in grid)
    const video = item.querySelector('video');
    if (video) {
      item.addEventListener('mouseenter', () => {
        video.muted = true;
        video.play();
      });
      item.addEventListener('mouseleave', () => {
        video.pause();
      });
    }
  });

  function openModal(content, i) {
    const doOpen = () => {
      const state = Flip.getState(content);
      modalContent.appendChild(content);
      activeIndex = i;

      modalTitle.textContent = content.dataset.title;
      modalDesc.innerHTML = content.dataset.desc;

      document.body.classList.add('portfolio-modal-open');
      document.body.style.overflow = 'hidden';
      gsap.set(modal, { autoAlpha: 1, pointerEvents: 'all', zIndex: 2000 });

      Flip.from(state, { duration: 0.7, ease: 'power1.inOut' });
      gsap.to(modalOverlay, { autoAlpha: 1, duration: 0.35 });
      gsap.to(modalFooter, { autoAlpha: 1, duration: 0.4, delay: 0.3 });

      // Play video in modal — lazy load full quality src
      const video = content.querySelector('video');
      const playBtn = content.querySelector('.portfolio__play-btn');
      if (video) {
        video.style.display = 'block';
        video.muted = true;
        video.setAttribute('controls', '');

        const fullSrc = video.dataset.fullSrc;
        const source = video.querySelector('source');
        const needsLoad = fullSrc && source && source.src !== fullSrc;

        const doPlay = () => {
          video.play().catch(() => {
            if (playBtn) playBtn.classList.add('is-visible');
          });
          if (playBtn) playBtn.classList.remove('is-visible');
        };

        if (needsLoad) {
          source.src = fullSrc;
        }

        if (needsLoad || video.readyState < 3) {
          video.load();
          video.addEventListener('canplay', doPlay, { once: true });
          setTimeout(function () {
            if (video.paused) doPlay();
          }, 1500);
        } else {
          doPlay();
        }

        video.onpause = () => {
          if (playBtn) playBtn.classList.add('is-visible');
          video.removeAttribute('controls');
        };
        video.onplay = () => {
          if (playBtn) playBtn.classList.remove('is-visible');
          video.setAttribute('controls', '');
        };
      }
    };

    // Na mobile: scroll do sekcji portfolio jeśli jest ucięta
    if (window.innerWidth < 1024) {
      const portfolioSection = document.querySelector('.portfolio');
      if (portfolioSection) {
        const rect = portfolioSection.getBoundingClientRect();
        if (rect.top < -5 || rect.top > 20) {
          window.scrollTo({ top: window.scrollY + rect.top, behavior: 'smooth' });
          setTimeout(doOpen, 400);
          return;
        }
      }
    }

    doOpen();
  }

  function closeModal() {
    if (activeIndex === undefined) return;

    const content = itemContents[activeIndex];
    const item = items[activeIndex];
    const closingIndex = activeIndex;
    activeIndex = undefined;

    // Zmierz aktualne wymiary contentu w modalu i docelowe w kafelku
    const contentRect = content.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    // Ustaw content na fixed z aktualną pozycją (startowy stan)
    gsap.set(content, {
      position: 'fixed',
      top: contentRect.top,
      left: contentRect.left,
      width: contentRect.width,
      height: contentRect.height,
      zIndex: 9999,
    });

    // Tytuł i opis rozsuwają się z fade outem
    gsap.to(modalTitle, { x: -60, autoAlpha: 0, duration: 0.4, ease: 'power2.in' });
    gsap.to(modalDesc, { x: 60, autoAlpha: 0, duration: 0.4, ease: 'power2.in' });
    gsap.to(modalOverlay, { autoAlpha: 0, duration: 0.5, ease: 'power1.inOut' });
    gsap.set(modal, { pointerEvents: 'none' });

    // Animuj z pozycji modala do pozycji kafelka
    gsap.to(content, {
      width: itemRect.width,
      height: itemRect.height,
      top: itemRect.top,
      left: itemRect.left,
      borderRadius: '1rem',
      duration: 0.7,
      ease: 'power1.inOut',
      onComplete: () => {
        // Po animacji: wróć content do kafelka i wyczyść inline styles
        item.appendChild(content);
        gsap.set(content, { clearProps: 'all' });
        gsap.set(modal, { autoAlpha: 0, zIndex: -1 });
        gsap.set(modalFooter, { autoAlpha: 0 });
        gsap.set([modalTitle, modalDesc], { clearProps: 'x,opacity,visibility' });
        document.body.classList.remove('portfolio-modal-open');
        document.body.style.overflow = '';
      },
    });

    // Pause video when closing modal
    const video = content.querySelector('video');
    const playBtn = content.querySelector('.portfolio__play-btn');
    if (video) {
      video.onpause = null;
      video.onplay = null;
      video.pause();
      video.currentTime = 0;
      video.removeAttribute('controls');
      video.style.display = '';
      video.muted = true;
    }
    if (playBtn) playBtn.classList.remove('is-visible');
  }

  itemContents.forEach((content, i) => {
    content.addEventListener('click', (e) => {
      if (e.target.closest('.portfolio__play-btn')) return;
      if (activeIndex !== undefined) {
        // W modalu — klik na video lub kontrolki nie zamyka
        if (e.target.closest('video')) return;
        closeModal();
      } else {
        openModal(content, i);
      }
    });
  });

  // Play button click in grid opens modal
  items.forEach((item, i) => {
    const playBtn = item.querySelector('.portfolio__play-btn');
    if (playBtn) {
      playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (activeIndex !== undefined) return;
        openModal(itemContents[i], i);
      });
    }
  });

  // Play button click — toggle play/pause in modal
  itemContents.forEach((content) => {
    const playBtn = content.querySelector('.portfolio__play-btn');
    const video = content.querySelector('video');
    if (playBtn && video) {
      playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (activeIndex === undefined) return;
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  });

  modal.querySelector('.portfolio__modal-close')?.addEventListener('click', closeModal);
  modalOverlay?.addEventListener('click', closeModal);

  // Mobile: swipe down zamyka modal
  let touchStartY = 0;
  modal.addEventListener(
    'touchstart',
    (e) => {
      touchStartY = e.touches[0].clientY;
    },
    { passive: true },
  );
  modal.addEventListener(
    'touchend',
    (e) => {
      if (activeIndex === undefined) return;
      const delta = e.changedTouches[0].clientY - touchStartY;
      if (delta > 60) closeModal();
    },
    { passive: true },
  );

  // === Flip Filtering (radio buttons) ===
  const radios = gsap.utils.toArray('input[name="portfolio-filter"]');

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      const value = radio.value;
      const isMobile = window.innerWidth < 1024;

      if (isMobile) {
        // Mobile: prosty fade bez Flip (Flip psuje 2-kolumnowy grid)
        items.forEach((item) => {
          const show = value === 'all' || item.classList.contains(value);
          if (show) {
            item.style.display = 'inline-flex';
            gsap.fromTo(
              item,
              { opacity: 0, scale: 0.9 },
              { opacity: 1, scale: 1, duration: 0.35, ease: 'power2.out' },
            );
          } else {
            gsap.to(item, {
              opacity: 0,
              scale: 0.9,
              duration: 0.25,
              ease: 'power2.in',
              onComplete: () => {
                item.style.display = 'none';
              },
            });
          }
        });
      } else {
        // Desktop: Flip animation
        const state = Flip.getState(items);

        items.forEach((item) => {
          if (value === 'all') {
            item.style.display = 'inline-flex';
          } else {
            const match = item.classList.contains(value);
            item.style.display = match ? 'inline-flex' : 'none';
          }
        });

        Flip.from(state, {
          duration: 0.7,
          scale: true,
          ease: 'power1.inOut',
          stagger: 0.08,
          absolute: true,
          onEnter: (els) =>
            gsap.fromTo(els, { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, duration: 1 }),
          onLeave: (els) => gsap.to(els, { opacity: 0, scale: 0, duration: 1 }),
        });
      }
    });
  });
}

/* =========================
   SOCIAL DOCK HOVER (macOS-style)
========================= */

function initSocialDock() {
  const nav = document.querySelector('.site-social');
  if (!nav) return;

  const items = nav.querySelectorAll('li');
  if (!items.length) return;

  function onEnter(e) {
    const hovered = e.currentTarget;
    const idx = Array.from(items).indexOf(hovered);

    items.forEach((item, i) => {
      const dist = Math.abs(i - idx);

      if (dist === 0) {
        gsap.to(item, { scale: 1.4, y: -6, duration: 0.3, ease: 'back.out(1.7)' });
      } else if (dist === 1) {
        gsap.to(item, { scale: 1, y: 0, x: i < idx ? -4 : 4, duration: 0.3, ease: 'power2.out' });
      } else {
        gsap.to(item, { scale: 1, y: 0, x: 0, duration: 0.3, ease: 'power2.out' });
      }
    });
  }

  function onLeaveNav() {
    items.forEach((item) => {
      gsap.to(item, { scale: 1, y: 0, x: 0, duration: 0.4, ease: 'power2.out' });
    });
  }

  items.forEach((item) => {
    item.addEventListener('mouseenter', onEnter);
  });

  nav.addEventListener('mouseleave', onLeaveNav);
}

/* =========================
   ANCHOR SCROLL
========================= */

function initAnchorScrolling() {
  // Mapping hash → label w master timeline (desktop)
  const panelLabels = {
    concept: 'panel-concept',
    oferta: 'offerActive-0',
    portfolio: 'portfolio-ready',
    trust: 'panel-trust',
    'o-nas': 'passion-ready',
    kontakt: 'panel-contact',
  };

  function getScrollPosForHash(id) {
    const master = window.__horizontalMaster;
    if (!master || !master.scrollTrigger) return null;

    const label = panelLabels[id];
    if (label === undefined) return null;

    const labelTime = master.labels[label];
    if (labelTime === undefined) return null;

    const st = master.scrollTrigger;
    const progress = labelTime / master.duration();
    return st.start + progress * (st.end - st.start);
  }

  function scrollToHash(hash) {
    const id = hash.replace('#', '');

    // Desktop: skok do pozycji odpowiadającej labelowi w master timeline
    const scrollPos = getScrollPosForHash(id);
    if (scrollPos !== null) {
      // Wymuś flip do końca przed skokiem (jeśli jesteśmy w starter strefie)
      const flipTl = window.__flipTimeline;
      if (flipTl && flipTl.scrollTrigger) {
        const fst = flipTl.scrollTrigger;
        if (window.scrollY < fst.end) {
          flipTl.progress(1, true);
        }
      }
      window.scrollTo(0, scrollPos);
      ScrollTrigger.update();
      return;
    }

    // Mobile: wymuś mobile flip + skocz za jego pin
    const mobileFlipTl = window.__mobileFlipTimeline;
    if (mobileFlipTl && mobileFlipTl.scrollTrigger) {
      const target = document.getElementById(id);
      if (target) {
        const st = mobileFlipTl.scrollTrigger;
        if (window.scrollY < st.end) {
          mobileFlipTl.progress(1, true);
          ScrollTrigger.refresh();
        }
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const scrollPos = Math.max(targetTop, st.end);
        gsap.to(window, {
          scrollTo: { y: scrollPos, autoKill: false },
          duration: 1.2,
          ease: 'power2.inOut',
        });
        return;
      }
    }

    // Fallback
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function jumpToHash(hash) {
    const id = hash.replace('#', '');

    // Wspólny krok: wymuś oba Flip timeline'y do końca zanim cokolwiek się poruszy.
    // Bez tego Flip nie zna stanu finalnego i psuje układ przy nagłym skoku scrolla.
    const flipTl = window.__flipTimeline || window.__mobileFlipTimeline;
    if (flipTl) {
      flipTl.progress(1, true);
    }

    // Desktop: horizontal pinned master
    const master = window.__horizontalMaster;
    if (master && master.scrollTrigger) {
      ScrollTrigger.refresh();
      const scrollPos = getScrollPosForHash(id);
      if (scrollPos !== null) {
        gsap.to(window, {
          scrollTo: { y: scrollPos, autoKill: false },
          duration: 0,
          onComplete: () => ScrollTrigger.update(),
        });
        return;
      }
    }

    // Mobile: panele w normalnym flow, ale starter jest pinowany (end: +=300%).
    // scrollIntoView nie może być użyte — skacze do elementu ignorując pin offset.
    // Wymuś starter do końca pinu i użyj scrollTo przez GSAP.
    const mobileFlipTl = window.__mobileFlipTimeline;
    if (mobileFlipTl && mobileFlipTl.scrollTrigger) {
      ScrollTrigger.refresh();
      const target = document.getElementById(id);
      if (target) {
        const st = mobileFlipTl.scrollTrigger;
        // Pozycja elementu w dokumencie po rozwiązaniu pinu
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        // Musi być co najmniej za końcem pinu startera
        const scrollPos = Math.max(targetTop, st.end);
        gsap.to(window, {
          scrollTo: { y: scrollPos, autoKill: false },
          duration: 0,
          onComplete: () => ScrollTrigger.update(),
        });
        return;
      }
    }

    // Fallback — brak pinnowanych sekcji
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ block: 'start' });
    }
  }

  // Interceptuj kliknięcia na wszystkie linki z # na tej samej stronie
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    // Obsłuż "#hash", "/#hash" oraz pełne URL-e WP-menu typu "http://host/#hash"
    // lub "http://host/path/#hash" — pod warunkiem że wskazują tę samą stronę.
    let hash = null;
    if (href.startsWith('#') && href.length > 1) {
      hash = href;
    } else {
      // link.hash/host/pathname to znormalizowane DOM properties (rozwiązują względne URL-e)
      const linkHash = link.hash;
      if (
        linkHash &&
        linkHash.length > 1 &&
        link.host === window.location.host &&
        link.pathname === window.location.pathname
      ) {
        hash = linkHash;
      }
    }
    if (!hash) return;

    e.preventDefault();

    const mobileMenu = document.getElementById('mobileMenu');
    if (mobileMenu && mobileMenu.classList.contains('is-open')) {
      setTimeout(() => scrollToHash(hash), 400);
    } else {
      scrollToHash(hash);
    }
  });

  // Obsłuż hash w URL przy załadowaniu strony
  // window.__pendingHash jest ustawiony przez inline script w header.php
  // (scroll zresetowany do 0 jeszcze przed DOMContentLoaded)
  const pageHash = window.__pendingHash || '';
  if (pageHash) {
    window.__pendingHash = '';
    // rAF żeby przeglądarka zdążyła wyrenderować układ przed skokiem
    requestAnimationFrame(() => jumpToHash(pageHash));
  }
}

/* =========================
   INIT
========================= */

document.addEventListener('DOMContentLoaded', () => {
  initSocialDock();
  initPortfolio();

  const mm = gsap.matchMedia();

  // Desktop (>= 1024px): pełne animacje GSAP
  mm.add('(min-width: 1024px)', () => {
    createTweenFlip();
    createTweenHorizontal();

    return () => {
      flipCtx && flipCtx.revert();
      horizontalCtx && horizontalCtx.revert();
    };
  });

  // Mobile + tablet (< 1024px)
  mm.add('(max-width: 1023px)', () => {
    if (typeof Swiper !== 'undefined' && document.querySelector('.offer__swiper')) {
      function loadSwiperSlideVideo(slide) {
        const source = slide.querySelector('source[data-src]');
        if (source && !source.src) {
          source.src = source.dataset.src;
          const video = source.parentElement;
          video.load();
          video.play().catch(() => {});
        }
      }

      const offerSwiper = new Swiper('.offer__swiper', {
        loop: true,
        speed: 750,
        grabCursor: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        pagination: { el: '.offer__swiper .swiper-pagination', clickable: true },
        on: {
          afterInit(swiper) {
            loadSwiperSlideVideo(swiper.slides[swiper.activeIndex]);
          },
          slideChange(swiper) {
            loadSwiperSlideVideo(swiper.slides[swiper.activeIndex]);
          },
        },
      });
    }

    // Mobile starter: statyczny bento grid w stanie finalnym od razu
    const starterEl = document.querySelector('#starter');
    if (!starterEl) return;

    starterEl.classList.add('starter--mobile-final');
    window.__mobileFlipTimeline = null;

    // Odtwórz wideo — na mobile podmień src na vid_mobile jeśli dostępny
    starterEl.querySelectorAll('video').forEach((v) => {
      const source = v.querySelector('source[data-src-mobile]');
      if (source && source.dataset.srcMobile && source.dataset.srcMobile !== source.src) {
        source.src = source.dataset.srcMobile;
        v.load();
      }
      v.play().catch(() => {});
    });

    // Logo: scroll-driven z centrum do headera (bez pinu)
    const logo = document.querySelector('.site-header__logo');
    const siteHeader = document.querySelector('.site-header');
    if (logo) {
      const getLogoStartY = () =>
        window.innerHeight / 2 - logo.offsetHeight / 2 - logo.getBoundingClientRect().top;
      gsap.fromTo(
        logo,
        { xPercent: -50, x: 0, y: getLogoStartY, scale: 1.1 },
        {
          xPercent: -50,
          x: 0,
          y: 0,
          scale: 1,
          ease: 'power2.inOut',
          scrollTrigger: {
            trigger: starterEl,
            start: 'top top',
            end: '+=80%',
            scrub: true,
            invalidateOnRefresh: true,
            onLeave: () => {
              gsap.set(logo, { pointerEvents: 'auto' });
              siteHeader && siteHeader.classList.add('header--menu-visible');
            },
            onEnterBack: () => {
              gsap.set(logo, { pointerEvents: 'none' });
              siteHeader && siteHeader.classList.remove('header--menu-visible');
            },
          },
        },
      );
    }
  });

  // Anchor scrolling — po inicjalizacji wszystkich ScrollTriggerów
  initAnchorScrolling();
});
